/** Адреса фасада поиска Platform (`ProductSearchController`, RP-A6a). */
export const PLATFORM_SEARCH_URLS = {
  photo: '/api/platform/v1/search/photo/stream',
  health: '/api/platform/v1/search/health',
  /** Подготовка поиска: Platform шлёт службе текстового поиска холостой запрос (RP-FB52). */
  warmup: '/api/platform/v1/search/warmup',
  /** «Это он»: прочитанный на снимке текст запоминается как поисковые фразы подтверждённого товара. */
  confirm: '/api/platform/v1/search/confirm',
  /** Действие человека над ответом поиска («Это он», «Нет, другой», «Ничего из этого», «Прикрепить», «Создать») — метки для обучения (RP-FB77). */
  feedback: '/api/platform/v1/search/feedback',
  /** Сводка времени боевых поисков по этапам за период (только системному администратору). */
  timings: '/api/platform/v1/search/timings',
  /** Время по этапам одного поиска по его номеру из ответа. */
  timingOf: (searchId: string) => `/api/platform/v1/search/timings/${encodeURIComponent(searchId)}`,
} as const
